import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { MessageCount } from './../interfaces/message-count';
import { Message } from './../interfaces/message';
import { ClubBillingMessage } from './../interfaces/club-billing-message';
import { RegistrationCompleteMessage } from './../interfaces/registration-complete-message';
import { PaymentReminder } from './../interfaces/payment-reminder';
import { ShortCodes } from '../models';

@Injectable()
export class MessageService {

  private _url = '/api/ClubBillingMessage';

  constructor(private http: HttpClient) { }

  getMessageCounts(clubProgramID: string | number) {
    return this.http.get<MessageCount>(this._url + '/get-clubBillingMessageCounts/' + clubProgramID);
  }

  getPreSetMessages(clubProgramID: number, programType: number): Observable<Message[]> {
    return this.http.get<Message[]>(this._url + '/get-preSetMessagesByTypeID/' + clubProgramID + '/' + programType);
  }

  /* Tryout preset message. */
  // getTryoutPreSetMessages(clubProgramID: string): Observable<Message[]> {
  //  return this.http.get<Message[]>(this._url + '/get-preSetMessagesByTypeID/' + clubProgramID + '/2');
  // }

  getClubBillingMessage(ClubBillingMessageID: number) {
    return this.http.get<ClubBillingMessage>(this._url + '/get-message-options-details/' + ClubBillingMessageID);
  }

  saveMessage(clubBillingMessage: ClubBillingMessage) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/save-message', clubBillingMessage, httpOptions);
  }

  // Save "Registration Complete Message"
  saveRegistrationCompleteMessage(registrationCompleteMessage: RegistrationCompleteMessage) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/edit-message', registrationCompleteMessage, httpOptions);
  }

  // Save "Payment Reminder"
  savePaymentReminder(paymentReminder: PaymentReminder) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/edit-message', paymentReminder, httpOptions);
  }

  // Text transform
  applyShortCodes(templateBody: string = '', data: any = {}): string {
    if (templateBody && typeof templateBody === 'string') {
      let str = templateBody;
      ShortCodes.forEach(shortCode => {
        str = data[shortCode.key] ? this.replaceAll(str, shortCode.code, data[shortCode.key]) : str;
      });
      return str;
    } else {
      return '';
    }
  }

  private replaceAll(str1: string, src: string, tar: string): string {
    return str1.split(src).join(tar);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/message.service.ts